<div class="upp-konva-floor-plan-host" data-id="upp-konva-integration">
  <upp-floor-plan-stage
    #floor
    [model]="konvaHostSceneModel"
    [presentationEpoch]="model.presentationEpoch"
    [preferences]="konvaHostPresentationPreferences"
    [edit]="model.mode === 'EDIT'"
    [active]="active"
    [theme]="stageMergedTheme"
    [roomBackgroundPointerMode]="stageRoomBackgroundPointerMode"
    [vertexPreviewAnchorId]="konvaHostVertexPreviewAnchorId"
    (onSelect)="onFloorStageSelect($event)"
    (elementClick)="onActivate($event)"
    (elementGeometryChange)="onGeometryCommit($event)"
    (roomBackgroundDoubleClick)="onRoomBackgroundDoubleClick($event)"
    (roomBackgroundSingleClick)="onRoomBackgroundSingleClick($event)"
    (vertexDoubleClick)="onVertexDoubleClick($event)"
    (viewTransformChange)="onTransform.emit($event)"
  />
</div>
